module.exports = __webpack_public_path__ + "img/product-icon_5.7c9968f4.png";